import type { PlayerSummary } from '@brush/api-client';

/**
 * The room's players holding a file's cards, asked in batches of at most `size` — the server refuses more
 * in one request (`too_many_cards`, `FIND_BY_CARDS_MAX`) — and merged into one answer, so no file can be
 * too large to look up (gate addition A2). Importing only types, so `node --test` drives it directly.
 */
export async function findByCardsInBatches(
  cards: readonly string[],
  size: number,
  fetchBatch: (batch: readonly string[]) => Promise<readonly PlayerSummary[]>,
): Promise<PlayerSummary[]> {
  const batches: (readonly string[])[] = [];
  for (let i = 0; i < cards.length; i += size) batches.push(cards.slice(i, i + size));
  // Side by side: each is one statement on the server, and a file of 2,000 cards is two.
  const answers = await Promise.all(batches.map((batch) => fetchBatch(batch)));
  return answers.flat();
}
